import React, { useEffect, useRef, useState } from "react";
import styles from "./style.module.css";
import Slider from "react-slick";
import { useLocation } from "react-router-dom";

const VideosSection = () => {

  const settings = {
    dots: true,
    infinite: true,
    speed: 2000,
    slidesToShow: 3,
    autoplay: true,
    slidesToScroll: 3,
    prevArrow: (
      <button className={styles.btnopt}>
        <i class="fa-solid fa-chevron-left"></i>
      </button>
    ),
    nextArrow: (
      <button className={styles.btnopt}>
        <i class="fa-solid fa-chevron-right"></i>
      </button>
    ),
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className={`${styles.section}`} id="oa-y-9">
      <div className={`${styles.container} container`}>
        <div className={`text-center ${styles.GlobalText}`}>
          Here’s why our clients trust us with their portfolio management.
        </div>

        <div className={`${styles.desktopView}`}>
          <div style={{ width: '100%', margin: '0 auto', display: 'flex', flexWrap: 'wrap', gap: '1rem', alignItems: 'center', justifyContent: 'center' }}>
            <iframe
              className={`${styles.videoIframe}`}
              src='https://www.youtube.com/embed/akCsYoRcVfU?feature=oembed&rel=0&mute=0&loop=0&controls=1'>
            </iframe>

            <iframe
              className={`${styles.videoIframe}`}
              src='https://www.youtube.com/embed/3-MGUU4QWOc?feature=oembed&rel=0&mute=0&loop=0&controls=1'>
            </iframe>

            <iframe
              className={`${styles.videoIframe}`}
              src='https://www.youtube.com/embed/Bq7vHocVG14?feature=oembed&rel=0&mute=0&loop=0&controls=1'>
            </iframe>
          </div>
        </div>
        <div className={`${styles.mobileView}`}>
          <div style={{padding:'0 1rem'}}>
            <Slider {...settings}>
              <iframe
                className={`${styles.videoIframe}`}
                src='https://www.youtube.com/embed/akCsYoRcVfU?feature=oembed&rel=0&mute=0&loop=0&controls=1'>
              </iframe>

              <iframe
                className={`${styles.videoIframe}`}
                src='https://www.youtube.com/embed/3-MGUU4QWOc?feature=oembed&rel=0&mute=0&loop=0&controls=1'>
              </iframe>

              <iframe
                className={`${styles.videoIframe}`}
                src='https://www.youtube.com/embed/Bq7vHocVG14?feature=oembed&rel=0&mute=0&loop=0&controls=1'>
              </iframe>
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideosSection;
